// (function () {
//   function runAfterPageLoaded(callback) {
//     if (document.body.classList.contains('page-loaded')) {
//       callback();
//       return;
//     }

//     window.addEventListener(
//       'load',
//       function () {
//         window.requestAnimationFrame(function () {
//           if (document.body.classList.contains('page-loaded')) {
//             callback();
//           } else {
//             setTimeout(callback, 100);
//           }
//         });
//       },
//       { once: true }
//     );
//   }

//   function initCursorPictureHero(scope) {
//     var heroes = (scope || document).querySelectorAll('[data-cursor-picture-hero]');

//     heroes.forEach(function (hero) {
//       if (hero.dataset.cursorHeroInit === 'true') return;
//       hero.dataset.cursorHeroInit = 'true';

//       if (!window.gsap) {
//         console.warn('GSAP is not loaded for cursor picture hero animation.');
//         return;
//       }

//       var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
//       var coarsePointer = window.matchMedia('(pointer: coarse)').matches;

//       if (reduceMotion || coarsePointer) return;

//       var pictures = hero.querySelectorAll('.cursor-picture');
//       if (!pictures.length) return;

//       var currentIndex = 0;
//       var lastX = 0;
//       var lastY = 0;
//       var started = false;
//       var zIndexCounter = 80;
//       var distanceThreshold = 65;

//       gsap.set(pictures, {
//         xPercent: -50,
//         yPercent: -50,
//         opacity: 0,
//         visibility: 'hidden',
//         scale: 0.8,
//         zIndex: 70
//       });

//       function getDistance(x1, y1, x2, y2) {
//         var dx = x2 - x1;
//         var dy = y2 - y1;

//         return Math.sqrt(dx * dx + dy * dy);
//       }

//       function showPicture(x, y) {
//         var picture = pictures[currentIndex];

//         currentIndex = (currentIndex + 1) % pictures.length;

//         var rotation = gsap.utils.random(-10, 10);

//         gsap.killTweensOf(picture);

//         gsap.set(picture, {
//           xPercent: -50,
//           yPercent: -50,
//           x: x,
//           y: y,
//           zIndex: zIndexCounter++,
//           opacity: 1,
//           visibility: 'visible',
//           scale: 0.55,
//           rotation: rotation
//         });

//         gsap
//           .timeline()
//           .to(picture, {
//             opacity: 1,
//             visibility: 'visible',
//             scale: 0.7,
//             duration: 0.35,
//             ease: 'power3.out'
//           })
//           .to(
//             picture,
//             {
//               opacity: 0,
//               visibility: 'hidden',
//               scale: 0.7,
//               duration: 0.75,
//               ease: 'power2.out'
//             },
//             '+=0.45'
//           );
//       }

//       hero.addEventListener('mousemove', function (event) {
//         var rect = hero.getBoundingClientRect();
//         var x = event.clientX - rect.left;
//         var y = event.clientY - rect.top;

//         if (!started) {
//           started = true;
//           lastX = x;
//           lastY = y;
//           showPicture(x, y);
//           return;
//         }

//         if (getDistance(lastX, lastY, x, y) >= distanceThreshold) {
//           showPicture(x, y);
//           lastX = x;
//           lastY = y;
//         }
//       });

//       hero.addEventListener('mouseleave', function () {
//         gsap.to(pictures, {
//           opacity: 0,
//           visibility: 'hidden',
//           duration: 0.2,
//           overwrite: true
//         });
//       });
//     });
//   }

//   runAfterPageLoaded(function () {
//     initCursorPictureHero(document);
//   });

//   document.addEventListener('shopify:section:load', function (event) {
//     runAfterPageLoaded(function () {
//       initCursorPictureHero(event.target);
//     });
//   });
// })();



// (function () {
//   function runAfterPageLoaded(callback) {
//     if (document.body.classList.contains('page-loaded')) {
//       callback();
//       return;
//     }
//     document.addEventListener(
//       'DOMContentLoaded',
//       function () {
//         window.requestAnimationFrame(function () {
//           if (document.body.classList.contains('page-loaded')) {
//             callback();
//           } else {
//             setTimeout(callback, 100);
//           }
//         });
//       },
//       { once: true }
//     );
//   }

//   function initCursorPictureHero(scope) {
//     var heroes = (scope || document).querySelectorAll('[data-cursor-picture-hero]');

//     heroes.forEach(function (hero) {
//       if (hero.dataset.cursorHeroInit === 'true') return;
//       hero.dataset.cursorHeroInit = 'true';

//       if (!window.gsap) {
//         console.warn('GSAP is not loaded for cursor picture hero animation.');
//         return;
//       }

//       var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
//       var coarsePointer = window.matchMedia('(pointer: coarse)').matches;

//       if (reduceMotion || coarsePointer) return;

//       var pictures = hero.querySelectorAll('.cursor-picture');
//       var pictureCount = pictures.length;
//       if (!pictureCount) return;

//       var currentIndex = 0;
//       var lastX = 0;
//       var lastY = 0;
//       var started = false;
//       var zIndexCounter = 80;

//       // Use squared distance to avoid a sqrt() call on every mousemove.
//       var distanceThreshold = 65;
//       var distanceThresholdSq = distanceThreshold * distanceThreshold;

//       // Cache the hero's bounding rect instead of reading it on every
//       // mousemove (getBoundingClientRect forces a layout reflow).
//       var rect = hero.getBoundingClientRect();
//       var rectDirty = false;

//       function refreshRect() {
//         rect = hero.getBoundingClientRect();
//         rectDirty = false;
//       }

//       // Rect only needs to be recalculated if the page layout shifts
//       // (resize) or the hero moves in the viewport (scroll). Both are
//       // cheap flags checked lazily rather than forcing sync reflows.
//       window.addEventListener('resize', function () {
//         rectDirty = true;
//       }, { passive: true });
//       window.addEventListener('scroll', function () {
//         rectDirty = true;
//       }, { passive: true });

//       gsap.set(pictures, {
//         xPercent: -50,
//         yPercent: -50,
//         opacity: 0,
//         visibility: 'hidden',
//         scale: 0.8,
//         zIndex: 70
//       });

//       function getDistanceSq(x1, y1, x2, y2) {
//         var dx = x2 - x1;
//         var dy = y2 - y1;
//         return dx * dx + dy * dy;
//       }

//       function showPicture(x, y) {
//         var picture = pictures[currentIndex];

//         currentIndex = (currentIndex + 1) % pictureCount;

//         var rotation = gsap.utils.random(-10, 10);

//         gsap.killTweensOf(picture);

//         gsap.set(picture, {
//           xPercent: -50,
//           yPercent: -50,
//           x: x,
//           y: y,
//           zIndex: zIndexCounter++,
//           opacity: 1,
//           visibility: 'visible',
//           scale: 0.55,
//           rotation: rotation
//         });

//         gsap
//           .timeline()
//           .to(picture, {
//             opacity: 1,
//             visibility: 'visible',
//             scale: 0.7,
//             duration: 0.35,
//             ease: 'power3.out'
//           })
//           .to(
//             picture,
//             {
//               opacity: 0,
//               visibility: 'hidden',
//               scale: 0.7,
//               duration: 0.75,
//               ease: 'power2.out'
//             },
//             '+=0.45'
//           );
//       }

//       // Throttle mousemove handling to once per animation frame. Raw
//       // mousemove events can fire far more often than the screen
//       // refreshes, so anything beyond one update per frame is wasted work.
//       var pendingX = 0;
//       var pendingY = 0;
//       var rafScheduled = false;

//       function processMove() {
//         rafScheduled = false;

//         if (rectDirty) refreshRect();

//         var x = pendingX - rect.left;
//         var y = pendingY - rect.top;

//         if (!started) {
//           started = true;
//           lastX = x;
//           lastY = y;
//           showPicture(x, y);
//           return;
//         }

//         if (getDistanceSq(lastX, lastY, x, y) >= distanceThresholdSq) {
//           showPicture(x, y);
//           lastX = x;
//           lastY = y;
//         }
//       }

//       hero.addEventListener('mouseenter', function () {
//         refreshRect();
//       }, { passive: true });

//       hero.addEventListener('mousemove', function (event) {
//         pendingX = event.clientX;
//         pendingY = event.clientY;

//         if (!rafScheduled) {
//           rafScheduled = true;
//           window.requestAnimationFrame(processMove);
//         }
//       }, { passive: true });

//       hero.addEventListener('mouseleave', function () {
//         started = false;
//         gsap.to(pictures, {
//           opacity: 0,
//           visibility: 'hidden',
//           duration: 0.2,
//           overwrite: true
//         });
//       }, { passive: true });
//     });
//   }

//   // runAfterPageLoaded(function () {
//     initCursorPictureHero(document);
//   // });

//   // document.addEventListener('shopify:section:load', function (event) {
//     document.addEventListener('DOMContentLoaded', (event) => {
//       // runAfterPageLoaded(function () {
//         initCursorPictureHero(event.target);
//       // });
//     });

//   // });
// })();

// (function () {
//   function runAfterPageLoaded(callback) {
//     if (document.body.classList.contains('page-loaded')) {
//       callback();
//       return;
//     }

//     document.addEventListener(
//       'DOMContentLoaded',
//       function () {
//         window.requestAnimationFrame(function () {
//           if (document.body.classList.contains('page-loaded')) {
//             callback();
//           } else {
//             setTimeout(callback, 100);
//           }
//         });
//       },
//       { once: true }
//     );
//   }

//   function initCursorPictureHero(scope) {
//     var heroes = (scope || document).querySelectorAll(
//       '[data-cursor-picture-hero]'
//     );

//     heroes.forEach(function (hero) {
//       if (hero.dataset.cursorHeroInit === 'true') return;

//       hero.dataset.cursorHeroInit = 'true';

//       if (!window.gsap) {
//         console.warn(
//           'GSAP is not loaded for cursor picture hero animation.'
//         );
//         return;
//       }

//       var reduceMotion = window.matchMedia(
//         '(prefers-reduced-motion: reduce)'
//       ).matches;

//       if (reduceMotion) return;

//       var pictures = hero.querySelectorAll('.cursor-picture');
//       var pictureCount = pictures.length;

//       if (!pictureCount) return;

//       var currentIndex = 0;
//       var lastX = 0;
//       var lastY = 0;
//       var started = false;
//       var zIndexCounter = 80;

//       // Distance before creating another image
//       var distanceThreshold = 65;
//       var distanceThresholdSq =
//         distanceThreshold * distanceThreshold;

//       /*
//        * Cache hero bounding rect.
//        * This avoids getBoundingClientRect() on every move.
//        */
//       var rect = hero.getBoundingClientRect();
//       var rectDirty = false;

//       function refreshRect() {
//         rect = hero.getBoundingClientRect();
//         rectDirty = false;
//       }

//       window.addEventListener(
//         'resize',
//         function () {
//           rectDirty = true;
//         },
//         { passive: true }
//       );

//       window.addEventListener(
//         'scroll',
//         function () {
//           rectDirty = true;
//         },
//         { passive: true }
//       );

//       /*
//        * Initial picture state
//        */
//       gsap.set(pictures, {
//         xPercent: -50,
//         yPercent: -50,
//         opacity: 0,
//         visibility: 'hidden',
//         scale: 0.8,
//         zIndex: 70
//       });

//       function getDistanceSq(x1, y1, x2, y2) {
//         var dx = x2 - x1;
//         var dy = y2 - y1;

//         return dx * dx + dy * dy;
//       }

//       /*
//        * Show next picture
//        */
//       function showPicture(x, y) {
//         var picture = pictures[currentIndex];

//         currentIndex =
//           (currentIndex + 1) % pictureCount;

//         var rotation = gsap.utils.random(-10, 10);

//         gsap.killTweensOf(picture);

//         gsap.set(picture, {
//           xPercent: -50,
//           yPercent: -50,
//           x: x,
//           y: y,
//           zIndex: zIndexCounter++,
//           opacity: 1,
//           visibility: 'visible',
//           scale: 0.55,
//           rotation: rotation
//         });

//         gsap
//           .timeline()
//           .to(picture, {
//             opacity: 1,
//             visibility: 'visible',
//             scale: 0.7,
//             duration: 0.35,
//             ease: 'power3.out'
//           })
//           .to(
//             picture,
//             {
//               opacity: 0,
//               visibility: 'hidden',
//               scale: 0.7,
//               duration: 0.75,
//               ease: 'power2.out'
//             },
//             '+=0.45'
//           );
//       }

//       /*
//        * RequestAnimationFrame throttle
//        */
//       var pendingX = 0;
//       var pendingY = 0;
//       var rafScheduled = false;

//       function processMove() {
//         rafScheduled = false;

//         if (rectDirty) {
//           refreshRect();
//         }

//         var x = pendingX - rect.left;
//         var y = pendingY - rect.top;

//         /*
//          * First interaction
//          */
//         if (!started) {
//           started = true;

//           lastX = x;
//           lastY = y;

//           showPicture(x, y);

//           return;
//         }

//         /*
//          * Only create a new picture
//          * after moving a certain distance.
//          */
//         if (
//           getDistanceSq(
//             lastX,
//             lastY,
//             x,
//             y
//           ) >= distanceThresholdSq
//         ) {
//           showPicture(x, y);

//           lastX = x;
//           lastY = y;
//         }
//       }

//       /*
//        * Reset pictures
//        */
//       function hidePictures() {
//         started = false;

//         gsap.to(pictures, {
//           opacity: 0,
//           visibility: 'hidden',
//           duration: 0.2,
//           overwrite: true
//         });
//       }

//       /*
//        * ==========================================
//        * DESKTOP + MOUSE
//        * ==========================================
//        */

//       hero.addEventListener(
//         'mouseenter',
//         function () {
//           refreshRect();
//         },
//         { passive: true }
//       );

//       hero.addEventListener(
//         'mousemove',
//         function (event) {
//           /*
//            * Ignore mouse event if this is a touch pointer.
//            */
//           if (event.pointerType === 'touch') return;

//           pendingX = event.clientX;
//           pendingY = event.clientY;

//           if (!rafScheduled) {
//             rafScheduled = true;

//             window.requestAnimationFrame(
//               processMove
//             );
//           }
//         },
//         { passive: true }
//       );

//       hero.addEventListener(
//         'mouseleave',
//         function () {
//           hidePictures();
//         },
//         { passive: true }
//       );

//       /*
//        * ==========================================
//        * MOBILE / TOUCH
//        * ==========================================
//        *
//        * pointermove works for:
//        * - finger
//        * - stylus
//        * - mouse
//        */

//       hero.addEventListener(
//         'pointerenter',
//         function (event) {
//           /*
//            * On mobile this happens when
//            * the finger/stylus enters the element.
//            */
//           if (
//             event.pointerType === 'touch' ||
//             event.pointerType === 'pen'
//           ) {
//             refreshRect();
//           }
//         },
//         { passive: true }
//       );

//       hero.addEventListener(
//         'pointermove',
//         function (event) {
//           /*
//            * Handle only touch and pen here.
//            * Desktop mouse is already handled above.
//            */
//           if (
//             event.pointerType !== 'touch' &&
//             event.pointerType !== 'pen'
//           ) {
//             return;
//           }

//           pendingX = event.clientX;
//           pendingY = event.clientY;

//           if (!rafScheduled) {
//             rafScheduled = true;

//             window.requestAnimationFrame(
//               processMove
//             );
//           }
//         },
//         { passive: true }
//       );

//       /*
//        * When finger leaves the hero.
//        */
//       hero.addEventListener(
//         'pointerleave',
//         function (event) {
//           if (
//             event.pointerType === 'touch' ||
//             event.pointerType === 'pen'
//           ) {
//             hidePictures();
//           }
//         },
//         { passive: true }
//       );

//       /*
//        * Also support mobile tap.
//        *
//        * If the user simply taps the hero without
//        * dragging, create one picture at that point.
//        */
//       hero.addEventListener(
//         'pointerdown',
//         function (event) {
//           if (
//             event.pointerType !== 'touch' &&
//             event.pointerType !== 'pen'
//           ) {
//             return;
//           }

//           refreshRect();

//           pendingX = event.clientX;
//           pendingY = event.clientY;

//           var x = pendingX - rect.left;
//           var y = pendingY - rect.top;

//           started = true;
//           lastX = x;
//           lastY = y;

//           showPicture(x, y);
//         },
//         { passive: true }
//       );

//       /*
//        * Hide when touch ends.
//        */
//       hero.addEventListener(
//         'pointerup',
//         function (event) {
//           if (
//             event.pointerType === 'touch' ||
//             event.pointerType === 'pen'
//           ) {
//             /*
//              * Small delay allows the final image
//              * animation to remain visible.
//              */
//             setTimeout(function () {
//               hidePictures();
//             }, 150);
//           }
//         },
//         { passive: true }
//       );

//       hero.addEventListener(
//         'pointercancel',
//         function (event) {
//           if (
//             event.pointerType === 'touch' ||
//             event.pointerType === 'pen'
//           ) {
//             hidePictures();
//           }
//         },
//         { passive: true }
//       );
//     });
//   }

//   /*
//    * ==========================================
//    * INITIALIZE
//    * ==========================================
//    */

//   runAfterPageLoaded(function () {
//     initCursorPictureHero(document);
//   });

//   /*
//    * Shopify Theme Editor support
//    */
//   document.addEventListener(
//     'shopify:section:load',
//     function (event) {
//       initCursorPictureHero(event.target);
//     }
//   );
// })();

(function () {
  function runAfterPageLoaded(callback) {
    if (document.body.classList.contains('page-loaded')) {
      callback();
      return;
    }

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        window.requestAnimationFrame(function () {
          if (document.body.classList.contains('page-loaded')) {
            callback();
          } else {
            setTimeout(callback, 100);
          }
        });
      },
      { once: true }
    );
  }

  function initCursorPictureHero(scope) {
    var heroes = (scope || document).querySelectorAll(
      '[data-cursor-picture-hero]'
    );

    heroes.forEach(function (hero) {
      if (hero.dataset.cursorHeroInit === 'true') return;

      hero.dataset.cursorHeroInit = 'true';

      if (!window.gsap) {
        console.warn(
          'GSAP is not loaded for cursor picture hero animation.'
        );
        return;
      }

      var reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (reduceMotion) return;

      var pictures = hero.querySelectorAll('.cursor-picture');
      var pictureCount = pictures.length;

      if (!pictureCount) return;

      var currentIndex = 0;
      var lastX = 0;
      var lastY = 0;
      var started = false;
      var zIndexCounter = 80;

      /*
       * Distance the finger/mouse needs to move
       * before another image is created.
       */
      var distanceThreshold = 65;
      var distanceThresholdSq =
        distanceThreshold * distanceThreshold;

      /*
       * Cache hero position.
       */
      var rect = hero.getBoundingClientRect();
      var rectDirty = false;

      function refreshRect() {
        rect = hero.getBoundingClientRect();
        rectDirty = false;
      }

      window.addEventListener(
        'resize',
        function () {
          rectDirty = true;
        },
        { passive: true }
      );

      window.addEventListener(
        'scroll',
        function () {
          rectDirty = true;
        },
        { passive: true }
      );

      /*
       * Initial image state.
       */
      gsap.set(pictures, {
        xPercent: -50,
        yPercent: -50,
        opacity: 0,
        visibility: 'hidden',
        scale: 0.8,
        zIndex: 70
      });

      /*
       * Calculate distance without Math.sqrt().
       */
      function getDistanceSq(x1, y1, x2, y2) {
        var dx = x2 - x1;
        var dy = y2 - y1;

        return dx * dx + dy * dy;
      }

      /*
       * Show next image.
       */
      function showPicture(x, y) {
        var picture = pictures[currentIndex];

        currentIndex =
          (currentIndex + 1) % pictureCount;

        var rotation = gsap.utils.random(-10, 10);

        gsap.killTweensOf(picture);

        gsap.set(picture, {
          xPercent: -50,
          yPercent: -50,

          x: x,
          y: y,

          zIndex: zIndexCounter++,

          opacity: 1,
          visibility: 'visible',

          scale: 0.55,
          rotation: rotation
        });

        gsap
          .timeline()
          .to(picture, {
            scale: 0.7,
            opacity: 1,
            visibility: 'visible',

            duration: 0.35,

            ease: 'power3.out'
          })
          .to(
            picture,
            {
              opacity: 0,
              visibility: 'hidden',

              scale: 0.7,

              duration: 0.75,

              ease: 'power2.out'
            },
            '+=0.45'
          );
      }

      /*
       * Hide all images.
       */
      function hidePictures() {
        started = false;

        gsap.to(pictures, {
          opacity: 0,
          visibility: 'hidden',

          duration: 0.2,

          overwrite: true
        });
      }

      /*
       * ==========================================
       * DESKTOP MOUSE
       * ==========================================
       */

      hero.addEventListener(
        'mouseenter',
        function () {
          refreshRect();
        },
        { passive: true }
      );

      hero.addEventListener(
        'mousemove',
        function (event) {
          if (rectDirty) {
            refreshRect();
          }

          var x = event.clientX - rect.left;
          var y = event.clientY - rect.top;

          /*
           * First mouse movement.
           */
          if (!started) {
            started = true;

            lastX = x;
            lastY = y;

            showPicture(x, y);

            return;
          }

          /*
           * Create next image after moving
           * the required distance.
           */
          if (
            getDistanceSq(
              lastX,
              lastY,
              x,
              y
            ) >= distanceThresholdSq
          ) {
            showPicture(x, y);

            lastX = x;
            lastY = y;
          }
        },
        { passive: true }
      );

      hero.addEventListener(
        'mouseleave',
        function () {
          hidePictures();
        },
        { passive: true }
      );

      /*
       * ==========================================
       * MOBILE SWIPE / FINGER
       * ==========================================
       */

      var isTouchDevice = window.matchMedia(
        '(pointer: coarse)'
      ).matches;

      if (!isTouchDevice) return;

      var isTouching = false;

      /*
       * Prevent page scrolling while the user
       * is swiping inside the hero.
       *
       * IMPORTANT:
       * Also add CSS:
       *
       * [data-cursor-picture-hero] {
       *   touch-action: none;
       * }
       */

      hero.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches.length) return;

          refreshRect();

          var touch = event.touches[0];

          var x =
            touch.clientX - rect.left;

          var y =
            touch.clientY - rect.top;

          isTouching = true;

          started = true;

          lastX = x;
          lastY = y;

          /*
           * Show first image immediately.
           */
          showPicture(x, y);
        },
        { passive: true }
      );

      /*
       * Finger movement.
       *
       * This is the mobile equivalent
       * of desktop mousemove.
       */
      hero.addEventListener(
        'touchmove',
        function (event) {
          if (!isTouching) return;

          if (!event.touches.length) return;

          if (rectDirty) {
            refreshRect();
          }

          var touch = event.touches[0];

          var x =
            touch.clientX - rect.left;

          var y =
            touch.clientY - rect.top;

          /*
           * Same distance calculation as desktop.
           */
          if (
            getDistanceSq(
              lastX,
              lastY,
              x,
              y
            ) >= distanceThresholdSq
          ) {
            showPicture(x, y);

            lastX = x;
            lastY = y;
          }
        },
        { passive: true }
      );

      /*
       * Finger released.
       */
      hero.addEventListener(
        'touchend',
        function () {
          isTouching = false;

          /*
           * Let the final image animation
           * finish before hiding.
           */
          setTimeout(function () {
            if (!isTouching) {
              hidePictures();
            }
          }, 250);
        },
        { passive: true }
      );

      /*
       * Touch cancelled.
       */
      hero.addEventListener(
        'touchcancel',
        function () {
          isTouching = false;

          hidePictures();
        },
        { passive: true }
      );
    });
  }

  /*
   * ==========================================
   * INITIAL LOAD
   * ==========================================
   */

  runAfterPageLoaded(function () {
    initCursorPictureHero(document);
  });

  /*
   * ==========================================
   * SHOPIFY THEME EDITOR
   * ==========================================
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initCursorPictureHero(event.target);
    }
  );
})();